import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

// Shared data + actions for ONE problem move — used by both the Floor resolver
// (big-touch, scan-first) and the Desk drawer (typed entry). Same underlying
// endpoints, audience-appropriate presentation.
export function useProblemMove(id) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  const reload = useCallback(() => {
    if (!id) return;
    setLoading(true);
    api.get(`/problem-moves/${id}`)
      .then(({ data }) => setDetail(data))
      .catch(() => setDetail(null))
      .finally(() => setLoading(false));
  }, [id]);
  useEffect(() => { reload(); }, [reload]);

  // action: "move_to" (needs location_scan) | "send_back" | "confirm_empty".
  // Returns the API payload; throws on network/HTTP error so callers can toast.
  const doFix = useCallback(async (action, location_scan) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/problem-moves/${id}/fix`, { action, location_scan });
      return data;
    } finally { setBusy(false); }
  }, [id]);

  const doResolve = useCallback(async (note) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/problem-moves/${id}/resolve`, { note: note || undefined });
      return data;
    } finally { setBusy(false); }
  }, [id]);

  return { detail, loading, busy, reload, doFix, doResolve };
}
